import { refreshUpsells } from './utils.js';

const initUpsell = () => {
  const addToCart = (btn, id) => {
    const buttonLabel = btn.querySelector('span');

    const formData = {
      items: [{ id, quantity: 1 }],
    };

    buttonLabel.innerHTML = 'Adding...';

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        buttonLabel.innerHTML = 'Added!';
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  const addAllToCart = async (cards) => {
    const validCards = Array.from(cards).filter((card) => card.getAttribute('data-available') === 'true');

    const labels = validCards.map((card) => card.querySelector('.c-product-card__add > span'));
    const cartItems = document.querySelectorAll('.c-cart-item');

    const uniqueIds = [...new Set(validCards.map((el) => Number(el.dataset.productVariantId)))];
    const existingIds = new Set(Array.from(cartItems, (item) => Number(item.dataset.productId)));
    const idsToAdd = uniqueIds.filter((id) => !existingIds.has(id));

    const formData = {
      items: idsToAdd.map((id) => ({ id, quantity: 1 })),
    };

    labels.forEach((label) => {
      label.innerHTML = 'Adding...';
    });

    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      await res.json();

      labels.forEach((label) => {
        label.innerHTML = 'Added!';
      });
    } catch (error) {
      console.error('Error adding items:', error);
    }
  };

  const cartDrawer = document.querySelector('.cart-drawer');
  const mainCart = document.querySelector('.c-cart');
  const cartForm = document.querySelector('.c-cart-items__container form');

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        refreshUpsells();
        break;
      }
    }
  });

  if (cartForm) {
    observer.observe(cartForm, {
      childList: true,
      subtree: true,
    });
  }

  const ensureUpsellEventListeners = () => {
    const upsellAddButtons = document.querySelectorAll('.c-product-card__add:not([data-event-bound])');

    if (!upsellAddButtons.length) return;

    upsellAddButtons.forEach((button) => {
      button.setAttribute('data-event-bound', 'true');

      button.addEventListener('click', (e) => {
        e.preventDefault();
        const card = button.closest('.c-product-card');
        const id = card.dataset.productVariantId;
        addToCart(button, id);
      });
    });

    const addAllBtns = document.querySelectorAll('.c-upsell-cart__add-all-btn, .c-upsell-cart__add-all-btn--main');

    addAllBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const cartDrawer = document.querySelector('.cart-drawer');
        const cards = cartDrawer.querySelectorAll('.c-product-card');
        addAllToCart(cards);
      });
    });
  };

  window.ensureUpsellEventListeners = ensureUpsellEventListeners;

  cartDrawer.addEventListener('click', (e) => {
    ensureUpsellEventListeners();
  });

  mainCart?.addEventListener('click', (e) => {
    ensureUpsellEventListeners();
  });

  refreshUpsells();
  ensureUpsellEventListeners();

  document.addEventListener('cart:upsell', () => {
    try {
      refreshUpsells();
      if (typeof window.ensureUpsellEventListeners === 'function') {
        window.ensureUpsellEventListeners();
      }
    } catch (e) {
      console.warn('[Upsell] Failed to refresh on cart:upsell event', e);
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initUpsell();
});
